module.exports = __webpack_public_path__ + "img/KinokoTable03.b26002fd.jpg";